export default function pricePad(value) {
    const parts = String(value).split('.');
    if (parts.length === 1) {
        parts[1] = '00';
    } else {
        parts[1] = parts[1].padEnd(2, '0');
    }

    return parts.join(',');
}
